function toTypeStringOfObjectId (value) {
  return `ObjectId('${value}')`
}

async function findPricebook ({ key, server }) {
  const { data: pricebook } = await server.get({
    url: 'api/model/pricebooks',
    query: {
      query: {
        key,
      },
    },
  })
  return pricebook
}

const isInvisable = v => v === '' || v === undefined || v === null

function hasLensSpec (value) {
  const { lensSpec } = value
  if (!lensSpec) return false

  const { s, c } = lensSpec
  if (isInvisable(s)) return false
  if (isInvisable(c)) return false

  return true
}


async function findPriceRange ({ productRef, s, c, server }) {
  const { data: priceRanges } = await server.get({
    url: 'api/model/priceRanges',
    query: {
      query: {
        productRef: toTypeStringOfObjectId(productRef._id),
        range: {
          $elemMatch: { s: s * 100, c: c * 100 },
        },
      },
    },
  })

  return priceRanges && priceRanges[0]
}

export default async function findPrice ({ value, server }) {
  const { productRef, lensSpec: { s, c } } = value
  const query = { }
  const docs = { }

  if (!productRef) return null

  const pdtType = productRef.type
  if (pdtType === 'B' && !hasLensSpec(value)) return null

  if (pdtType === 'B') {
    const priceRangeRef = await findPriceRange({ productRef, s, c, server })
    if (!priceRangeRef) return null

    query.priceRangeRef = toTypeStringOfObjectId(priceRangeRef._id)
    docs.priceRangeRef = priceRangeRef
    docs.priceRangeDoc = priceRangeRef
  } else {
    query.productRef = toTypeStringOfObjectId(productRef._id)
  }


  const pricebooks = await findPricebook({ key: '批發價', server })
  if (pricebooks.length === 0) return undefined

  const pricebookRef = pricebooks[0]._id
  query.pricebookRef = toTypeStringOfObjectId(pricebookRef)
  docs.unitPricebookRef = pricebooks[0]
  docs.unitPricebookDoc = pricebooks[0]

  const { data: prices } = await server.get({
    url: 'api/model/prices',
    query: { query },
  })
  if (prices.length === 0) return null
  return { ...docs, unitPriceRef: prices[0], unitPriceDoc: prices[0] }
}



// WEBPACK FOOTER //
// ./src/components/PurchaseOrderEditor/ItemsEditor/ItemEditor/findPriceRelatedRefs.js